const { CognitoIdentityClient } = require("@aws-sdk/client-cognito-identity");
const { fromCognitoIdentityPool } = require("@aws-sdk/credential-provider-cognito-identity");


import {
    CognitoUserPool,
    CognitoUserAttribute,
    AuthenticationDetails,
    CognitoUser,
} from 'amazon-cognito-identity-js'


import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'


const config = {
    bucketName: process.env.VUE_APP_BUCKET_SOUNDS,
    bucketRegion: process.env.VUE_APP_BUCKET_REGION,
    cognitoRegion: process.env.VUE_APP_COGNITO_REGION,
    cognitoIdentityPoolId: process.env.VUE_APP_IDENTITY_POOL,
    cognitoUserPoolName: process.env.VUE_APP_USERPOOL_NAME,
    cognitoUserPoolId: process.env.VUE_APP_USERPOOL_ID,
    cognitoUserPoolId: process.env.VUE_APP_USERPOOL_ID,
    cognitoAppClient: process.env.VUE_APP_USERPOOL_CLIENT,
    cognitoFlow: process.env.VUE_APP_USERPOOL_FLOW,
}


function parseJwtBrowser(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
};


function parseJwtNode(token) {
    return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString());
}

function register_cognito(email, password, details, callback){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var attributeList = [];
    var dataEmail = {
        Name: 'email',
        Value: email,
    };
    var attributeEmail = new CognitoUserAttribute(dataEmail);
    attributeList.push(attributeEmail);
    // https://github.com/aws-amplify/amplify-js/tree/master/packages/amazon-cognito-identity-js
    //             (email, pass,     attributes,    validation, callback)
    userPool.signUp(email, password, attributeList, null, callback);
}

function confirm_cognito(creds, callback){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var cognitoUser = new CognitoUser({
        Username: creds.email,
        Pool: userPool
    });
    return cognitoUser.confirmRegistration(creds.code, true, callback);
}


function reset_password(creds, callback){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var cognitoUser = new CognitoUser({
        Username: creds.email,
        Pool: userPool
    });
    cognitoUser.forgotPassword({
        onSuccess: function(data) {
            // successfully initiated reset password request
            console.log('CodeDeliveryData from forgotPassword: ' + data);
            callback(data)
        },
        onFailure: function(err) {
            console.log('CodeDeliveryData from forgotPassword: ' + data);
            callback(err)
        },
    })
}


function confirmForgotCognito(creds, callback){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var cognitoUser = new CognitoUser({
        Username: creds.email,
        Pool: userPool
    });
    cognitoUser.confirmPassword(creds.code, creds.password, {
        onSuccess() {
            console.log('Password confirmed!');
            if (callback) {callback()}
        },
        onFailure(err) {
            console.log('Password not confirmed!');
            console.log(err);
        },
    })
}


function resetPasswordCognito(creds, callbacks){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var userCreds = new AuthenticationDetails({
        Username: creds.email,
        Password: creds.password_old
    })
    var cognitoUser = new CognitoUser({
        Username: creds.email,
        Pool: userPool});
    let parentOnSuccess = callbacks.onSuccess
    cognitoUser.authenticateUser(userCreds, {
        ...callbacks,
        onSuccess: function(results){
            var attributeList = [];
            attributeList.push(new CognitoUserAttribute({
                Name: "given_name",
                Value: creds.givenName,
            }))
            attributeList.push(new CognitoUserAttribute({
                Name: "family_name",
                Value: creds.familyName,
            }))
            cognitoUser.updateAttributes(attributeList, function(err, result) {
                if (err) {
                    console.log(err.message || JSON.stringify(err));
                    return;
                }
                console.log('call result: ' + result);
            });
            parentOnSuccess(results)
        },
        newPasswordRequired: function(userAttrs, requiredAttrs){
            console.log("auth.js - resetPassword - newPasswordRequired", userAttrs, requiredAttrs)
            cognitoUser.completeNewPasswordChallenge(creds.password, {}, this);
        }
    })
}


function login_cognito(creds, callbacks){
    var userPool = new CognitoUserPool({
        UserPoolId: config.cognitoUserPoolId,
        ClientId: config.cognitoAppClient
    });
    var userCreds = new AuthenticationDetails({
        Username: creds.email,
        Password: creds.password
    })
    var cognitoUser = new CognitoUser({
        Username: creds.email,
        Pool: userPool});
    return cognitoUser.authenticateUser(userCreds, callbacks)
}


const useLogin = defineStore('auth', {
    state: () => ({
        email: useStorage('email', ""),
        access_token: useStorage("access_token", ""),
        id_token: useStorage("id_token", ""),
        refresh_token: useStorage("refresh_token", ""),
    }),
    getters: {
        getRemaining() {
            if (this.id_token) {
                try {
                    let exp = parseJwtBrowser(this.tokens.id_token).exp
                    return () => {return exp - Date.now() / 1000}
                } catch(err) {
                    console.log("failed to parse the token", err)
                }
            }
            return () => {return -1}
        },
        isLogged() {
            if (this.id_token) {
                try {
                    let exp = parseJwtBrowser(this.tokens.id_token).exp
                    return () => {return (exp - Date.now() / 1000) > 0}
                }catch(err){
                    console.log("failed to parse the token", err)
                }
            }
            return () => {return false}
        },
        isAdmin() {
            if (!this.isLogged){return false}
            if (!this.claims){return false}
            if (!this.claims["cognito:groups"]){return false}
            return this.claims["cognito:groups"].includes("admin")
        },
        tokens(){
            return {
                access_token: this.access_token,
                id_token: this.id_token,
                refresh_token: this.refresh_token,
            }
        },
        claims(){
            if (this.id_token){
                try{
                    return parseJwtBrowser(this.id_token)
                }catch(err){
                    console.log("failed to parse the token", err)
                }
            }
            return {}
        }
    },
    actions: {
        setTokens(tokens){
            this.id_token = tokens.id_token
            this.access_token = tokens.access_token
            this.setEmail(parseJwtBrowser(this.id_token).email)
        },
        setEmail(email){
            this.email = email
        },
        logout(){
            this.access_token = ""
            this.id_token = ""
            this.refresh_token = ""
        },
        reset_password_required(creds, callback){
            let setTokens = this.setTokens
            let logout = this.logout
            let callbacks = {
                onFailure: function(err) {
                    console.log("error logging in", err);
                },
                onSuccess: function(resp){
                    // var AccessToken = resp.getAccessToken().getJwtToken();
                    // var IdToken = resp.getIdToken().getJwtToken();
                    // setTokens({access_token: AccessToken, id_token: IdToken})
                    if (callback){
                        callback(resp)
                    }
                },
            }
            resetPasswordCognito(creds, callbacks)
        },
        login(creds, callback){
            console.log("auth.js: logging in.......")
            let setTokens = this.setTokens
            let logout = this.logout
            let callbacks = {
                onSuccess: function(result) {
                    var AccessToken = result.getAccessToken().getJwtToken();
                    var IdToken = result.getIdToken().getJwtToken();
                    setTokens({
                        access_token: AccessToken,
                        id_token: IdToken
                    })
                    if (callback){
                        callback()
                    }
                },
                onFailure: function(err) {
                    console.log("error logging in", err);
                    logout()
                },
                newPasswordRequired: function(userAttr, requiredAttr){
                    console.log("repassword...", userAttr, requiredAttr)
                }
            }
            return login_cognito(creds, callbacks)
        },
        confirm(creds, callback){
            return confirm_cognito(creds, callback)
        },
    },
})


export {
    useLogin,
    login_cognito,
    config,
    confirmForgotCognito,
};
